export var getCssPrefix = function getCssPrefix(version) {
  var numericPart = version.replace(/[^0-9]/g, '');
  var isBeta = version.includes('beta');
  return "e-".concat(numericPart).concat(isBeta ? 'b' : '', "-");
};